import { IMAGES, SPOTIFY_ALBUM_URL, SPOTIFY_EMBED_URL, ALBUM_TITLE } from "./siteData";

const TRACKS = [
  {
    id: 1,
    image: IMAGES.portfolio1,
    alt: "Vicolo neon avvolto nella nebbia, atmosfera cinematografica",
    tag: "TEMI ELETTRONICI",
    tagColor: "text-[#818cf8]",
    hover: "group-hover:text-indigo-400",
    numColor: "text-indigo-400",
    title: "Post if U Still Don't Know What's Going On",
    num: "Traccia 01",
    desc: `In ascolto nell'album "${ALBUM_TITLE}".`,
  },
  {
    id: 2,
    image: IMAGES.portfolio2,
    alt: "Forme geometriche astratte in vetro su spazio viola profondo",
    tag: "SOUND DESIGN",
    tagColor: "text-[#c084fc]",
    hover: "group-hover:text-purple-400",
    numColor: "text-purple-400",
    title: "Mysterious Future Prismatic Age Galaxies",
    num: "Traccia 03",
    desc: `In ascolto nell'album "${ALBUM_TITLE}".`,
  },
  {
    id: 3,
    image: IMAGES.portfolio3,
    alt: "Silhouette cinematografica contro una forma d'onda proiettata",
    tag: "COLONNE PER CORTI",
    tagColor: "text-[#38bdf8]",
    hover: "group-hover:text-sky-400",
    numColor: "text-sky-400",
    title: "30400 140 piano retrofuturistic thriller",
    num: "Traccia 04",
    desc: `In ascolto nell'album "${ALBUM_TITLE}".`,
  },
];

const TrackCard = ({ track }) => (
  <div
    data-testid={`track-card-${track.id}`}
    className="group rounded-2xl bg-[#111320] border border-[#212638] hover:border-indigo-500/50 transition-colors p-5 flex flex-col justify-between"
  >
    <div className="rounded-xl aspect-video mb-4 relative overflow-hidden flex items-end p-4 border border-white/5">
      <img src={track.image} alt={track.alt} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
      <div className="relative z-10 w-full flex items-center justify-end text-xs font-mono-code text-white/90">
        <span className={track.tagColor}>{track.tag}</span>
      </div>
    </div>
    <div>
      <div className="flex items-center justify-between">
        <h3 className={`font-disp font-bold text-lg text-white transition-colors ${track.hover}`}>{track.title}</h3>
        <span className={`text-xs font-mono-code shrink-0 ml-3 ${track.numColor}`}>{track.num}</span>
      </div>
      <p className="text-xs font-serif-body text-[#94a3b8] mt-1">{track.desc}</p>
    </div>
    <div className="mt-4 pt-4 border-t border-[#1e2335] flex items-center justify-between">
      <a
        href={SPOTIFY_ALBUM_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`track-listen-btn-${track.id}`}
        className="inline-flex items-center gap-2 text-xs font-mono-code text-white bg-[#1e2235] px-3 py-1.5 rounded-lg hover:bg-indigo-600 transition-colors"
      >
        <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M8 5v14l11-7z" />
        </svg>
        Ascolta su Spotify
      </a>
      <span className="text-[11px] font-mono-code text-[#64748b]">DistroKid</span>
    </div>
  </div>
);

export const Portfolio = () => (
  <section id="portfolio" data-testid="portfolio-section" className="py-24 px-6 border-b border-[#1e2335]">
    <div className="max-w-6xl mx-auto space-y-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <span className="text-xs font-mono-code text-[#818cf8] uppercase tracking-widest">DISCOGRAFIA &amp; CORTI</span>
          <h2 className="text-3xl md:text-4xl font-disp font-bold text-white mt-1">Portfolio Sonoro &amp; Tracce</h2>
        </div>
        <p className="font-serif-body text-sm text-[#94a3b8] max-w-md">
          Ascolta l'album da 17 tracce distribuito con DistroKid: colonne sonore elettroniche per cinema, cortometraggi
          e opere visive.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TRACKS.map((track) => (
          <TrackCard key={track.id} track={track} />
        ))}
      </div>

      <div className="rounded-2xl bg-[#111320] border border-[#212638] p-5 md:p-6">
        <div className="flex items-center justify-between mb-4">
          <span className="text-xs font-mono-code text-[#818cf8] uppercase tracking-widest">
            Player integrato &mdash; {ALBUM_TITLE}
          </span>
          <a
            href={SPOTIFY_ALBUM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="spotify-open-link"
            className="text-xs font-mono-code text-[#94a3b8] hover:text-white transition-colors"
          >
            Apri su Spotify &rarr;
          </a>
        </div>
        <iframe
          data-testid="spotify-embed"
          title={`Spotify Embed: ${ALBUM_TITLE}`}
          src={SPOTIFY_EMBED_URL}
          width="100%"
          height="352"
          style={{ borderRadius: "12px", border: 0 }}
          allowFullScreen
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
      </div>
    </div>
  </section>
);
